import React, { Component } from 'react';

import client from 'js/utils/client';

import SubMenu from './SubMenu';
import './styles/mobileMenu.scss';
import './styles/burgerMenu.less';
import './styles/countries-flag.less';

import countries from '../utils/changeCountryData';

// const SubMenu = React.lazy(() => import('./SubMenu'));
const TopMenuItems = React.lazy(() => import('./TopMenuItems'));
const BurgerMenuDesktop = React.lazy(() =>
  import('../reusable-components/icons/header/BurgerMenuDesktop')
);
const BurgerMenuMobile = React.lazy(() =>
  import('../reusable-components/icons/header/BurgerMenuMobile')
);

const overlay = document.getElementById('header-click-overlay');

export default class MobileMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      openMenu: false,
      subMenus: {},
      subMenuID: null,
      isClosing: false,
      dataLoaded: false,
      initState: false
    };
    this.sliderController = this.sliderController.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
  }

  componentDidMount() {
    overlay.addEventListener('click', this.closeMenu);
  }

  componentDidUpdate(prevstate, state) {
    const { burgerMenuActive } = window.HeaderState;
    if (
      this.props.isMenuItemActive &&
      !burgerMenuActive &&
      window.HeaderState.index < 1
    ) {
      this.closeMenu();
      window.HeaderState.index += 1;
    }
    if (this.props.isMenuItemActive && state.openMenu) this.closeMenu();
    if (!burgerMenuActive && prevstate.openMenu) this.closeMenu();
  }

  componentWillUnmount() {
    overlay.removeEventListener('click', this.closeMenu);
  }

  getAllSubMenus = (arr, nextObj) => {
    arr.forEach(el => {
      if (el.items.length >= 1) {
        const next = nextObj;
        next[el.base_item_id] = el;
        return this.getAllSubMenus(el.items, next);
      }
      return null;
    });
    return nextObj;
  };

  sliderController = menuId => {
    this.setState({
      subMenuID: menuId
    });

    window.ua('trackStructEvent', 'navigation', 'show-overlay', String(menuId));
  };

  closeMenu = () => {
    this.props.toggleMobileMenu();
    this.props.handleOverLay(null, false, null);
    this.setState({ isClosing: true });
    window.ua(
      'trackStructEvent',
      'navigation',
      'hide-overlay',
      String(this.state.subMenuID)
    );

    setTimeout(() => {
      window.shouldHideHeaderOnScroll = true;
      this.setState({
        openMenu: false,
        subMenuID: null,
        isClosing: false
      });
    }, 220);
  };

  toggleMenu = () => {
    this.props.toggleMobileMenu();
    this.props.handleOverLay(null, true, null);
    if (
      Object.keys(this.state.subMenus).length === 0 &&
      this.state.subMenus.constructor === Object
    ) {
      if (this.state.initState) {
        this.fetchMenu_NEW();
      } else {
        this.fetchMenu();
      }
    }
    this.setState(prevState => {
      return { openMenu: !prevState.openMenu };
    });
    window.HeaderState.show('burgerMenuActive');
  };

  closeSubMenu = el => {
    if (this.state.subMenuID === el) {
      this.setState({ subMenuID: null });
    }
  };

  returnBurgerIcon = () => {
    if (window.innerWidth < 768) {
      return (
        <span
          className="burger-btn menu-btn burgerIcon"
          onClick={this.toggleMenu}
          role="button"
          tabIndex="0"
          style={{ outline: 'none' }}
          data-testid="hamburger-menu-button"
        >
          <BurgerMenuMobile />
        </span>
      );
    }
    const style = () =>
      window.innerWidth < 1024
        ? { marginTop: '18px', outline: 'none' }
        : { display: 'flex', alignItems: 'center', outline: 'none' };
    return (
      <span
        onClick={this.toggleMenu}
        role="button"
        tabIndex="0"
        style={style()}
        className="burgerIcon"
        data-testid="hamburger-menu-button"
      >
        <BurgerMenuDesktop />
      </span>
    );
  };

  fetchMenu() {
    client.get(this.props.url).then(response => {
      const items = response.data.top;
      const subMenus = this.getAllSubMenus(items, {});

      client.get(this.props.menuAPIURLService).then(serviceMenu => {
        if (serviceMenu.data.service !== undefined) {
          this.setState(() => {
            const newItems = [];
            for (let i = 0; i < serviceMenu.data.service.length; i++) {
              newItems.push(serviceMenu.data.service[i]);
            }
            const newSubMenus = this.getAllSubMenus(
              serviceMenu.data.service,
              {}
            );
            const newCountries = this.getAllSubMenus(countries, {});
            return {
              items: [...items, ...newItems, ...countries],
              subMenus: { ...subMenus, ...newSubMenus, ...newCountries },
              dataLoaded: true,
              breakline: items.filter(el => el.online).length
            };
          });
        }
      });
    });
  }

  fetchMenu_NEW() {
    const items = window.__INITIAL_NAVIGATION_STATE__.top;
    const subMenus = this.getAllSubMenus(items, {});

    if (window) {
      this.setState(() => {
        const newItems = [];
        for (
          let i = 0;
          i < window.__INITIAL_NAVIGATION_STATE__.service.length;
          i++
        ) {
          newItems.push(window.__INITIAL_NAVIGATION_STATE__.service[i]);
        }
        const newSubMenus = this.getAllSubMenus(
          window.__INITIAL_NAVIGATION_STATE__.service,
          {}
        );
        const newCountries = this.getAllSubMenus(countries, {});
        return {
          items: [...items, ...newItems, ...countries],
          subMenus: { ...subMenus, ...newSubMenus, ...newCountries },
          dataLoaded: true,
          breakline: items.filter(el => el.online).length
        };
      });
    }
  }

  render() {
    return (
      <div id="burgerMenu">
        {this.returnBurgerIcon()}
        <div
          id="burgerMenu"
          className={this.state.openMenu ? 'open' : 'closed'}
        >
          {this.state.openMenu && this.state.dataLoaded ? (
            <div
              className={
                this.state.isClosing
                  ? 'SlideMenu SlideMenu-leave-active'
                  : 'SlideMenu'
              }
            >
              <React.Suspense fallback={null}>
                <TopMenuItems
                  sliderController={this.sliderController}
                  closeMenu={this.closeMenu}
                  items={this.state.items}
                  breakline={this.state.breakline}
                />
                {this.state.subMenuID !== null ? (
                  <SubMenu
                    level={0}
                    subMenus={this.state.subMenus}
                    closeSubMenu={this.closeSubMenu}
                    closeMenu={this.closeMenu}
                    showAll={this.props.showAll}
                    sliderController={this.sliderController}
                    items={
                      this.state.subMenus[this.state.subMenuID]
                        ? this.state.subMenus[this.state.subMenuID].items
                        : []
                    }
                    el={this.state.items.find(
                      item => item.base_item_id === this.state.subMenuID
                    )}
                  />
                ) : null}
              </React.Suspense>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}
